import { Select } from 'components/Select/Select'
import { Item } from '@react-stately/collections'
import { ContentTypeSelectProps } from 'screens/Schedule/PostPromptsSection/Types'
import { ClockCheck, Email, Image03 } from 'blaze-ui/icons/24'
import { File02, ImageAvatar, Images, VideoOn } from 'blaze-ui/icons'
import { Iphone02 } from 'blaze-ui/icons/16'
import { useIsAvatarVideoAvailable } from 'hooks/useIsAvatarVideoAvailable'
import Styles from './ContentTypeSelect.module.scss'

const carouselItem = (
  <Item key="post:carousel" textValue="Carousel Post">
    <Images size={15} color="#EF6800" />
    Carousel Post
  </Item>
)

const avatarVideoItem = (
  <Item key="avatar_video" textValue="AI Avatar Video">
    <ImageAvatar size={15} color="#6A00FF" />
    AI Avatar Video
  </Item>
)

export const ContentTypeSelect = <T extends object>({
  isStrictBrandControl = false,
  ...props
}: ContentTypeSelectProps<T>) => {
  const isAvatarVideoAvailable = useIsAvatarVideoAvailable()

  return (
    <Select {...props} popoverClass={Styles.container} spanClass={Styles.spanClass} aria-label="Select content type">
      {[
        <Item key="post:still_image" textValue="Still image">
          <Image03 size={15} color="#FD4242" />
          Still image
        </Item>,
        ...(isStrictBrandControl ? [] : [carouselItem]),
        <Item key="post:video" textValue="Feed Video Post">
          <VideoOn size={15} color="#6A00FF" />
          Feed Video Post
        </Item>,
        <Item key="short" textValue="Short-form Video">
          <Iphone02 size={15} color="#00AAFF" />
          Short-form Video
        </Item>,
        ...(isAvatarVideoAvailable ? [avatarVideoItem] : []),
        <Item key="story" textValue="Story">
          <ClockCheck size={15} color="#FF37CA" />
          Story
        </Item>,
        <Item key="blog_post" textValue="Blog">
          <File02 size={15} color="#20A14F" />
          Blog
        </Item>,
        <Item key="newsletter" textValue="Newletter">
          <Email size={15} color="#FFAE00" />
          Email
        </Item>,
      ]}
    </Select>
  )
}
